import createImageIcon from './createImageIcon';
import path from './A-thin.svg';

export default createImageIcon({displayName: 'MarkerAIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/MarkerAIcon.js